import { ChannelError } from "../../../../features/api/apiSlice";

export const channelErrors = {
  [ChannelError["STREAM_ERROR"]]: "Ошибка трансляции",
  [ChannelError["TOKEN_AUTH_ERROR"]]: "Ошибка токена",
  [ChannelError["KEY_REQUIRED"]]: "Укажите ключ трансляции"
};